//Ready
let product = {};
let metafields = {};
let relationship = {};
let relationship_optional = {};
let product_relationship = {};
let product_relationship_optional = {};
let $contentRelationship = undefined;
let shopConfig = {};

let until = 0;
let until_current = 1;
let _total_count = 0;

let all_products = [];
const siluetas = [];
const tallas = [];
const colors = [];
const copas = [];
const cortes = [];

const { pathname } = location;
const split_pathname = pathname.split('/');
const last = split_pathname.slice(split_pathname.length - 2);

const cssArray = [];
let is_reposition = false;

// let filter_attr_silueta = '';
// let filter_attr_talla = '';
// let filter_attr_color = '';
// let filter_attr_copa = '';
// let filter_attr_corte = '';

const params = Object.fromEntries(new URLSearchParams(location.search));

let filter_attr_silueta = params?.filter_attr_silueta || '';
let filter_attr_color = params?.filter_attr_color || '';
let filter_attr_talla = params?.filter_attr_talla || '';
let filter_attr_copa = params?.filter_attr_copa || '';
let filter_attr_corte = params?.filter_attr_corte || '';


let all_active = [];

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || shopConfig.money_format);

    console.log('formatString', formatString);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    console.log('formatString', formatString);

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

const option = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
};

const formatter = new Intl.NumberFormat("en-US", option);


const sortForSize = (x, y) => {
    const orderBySize = ['xs', 's', 'm', 'l', 'xl', 'xxl'];
    if (orderBySize.findIndex(v => v == x.toLocaleLowerCase()) < orderBySize.findIndex(v => v == y.toLocaleLowerCase())) {
        return -1;
    }
    if (x > y) {
        return 1;
    }
    return 0;
}

const _get_web = ({ async = true, crossDomain = true, url, method = 'GET' }) => {
    const headers = {
        "x-shopify-access-token": "17c323584503b7340f72ca58979fa6cf",
        "cache-control": "no-cache",
    };
    // const domain =  `https://touche-colombia.myshopify.com/${url}`;
    const domain = `https://touche.co/${url}`;
    return $.ajax({
        async,
        crossDomain,
        method,
        headers,
        url: domain
    })
}

const _get = ({ async = true, crossDomain = true, apiUrl, method = 'POST', query = [] }) => {
    const domain = `https://dev5.conwayandpartners.com/productos-relationship/api_for_client/index.php`;
    return $.ajax({
        async,
        method: 'POST',
        crossDomain,
        url: domain,
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
            apiUrl,
            query
        })
    })
}

const get_metafields = ({ id }) => {
    return _get({
        apiUrl: `/admin/products/${id}/metafields.json`
    });
}

const done_get_product_relationship = ({ response }) => {
    product_relationship = response.product;
    print_relationship();
}

const done_get_product_relationship_optinal = ({ response }) => {
    product_relationship_optional = response.product;
    if (product.product_type.toLocaleLowerCase() == "bikini") {
        /**$(`#product-${product.id} .summary.entry-summary .btn-atc`).html(
          `${product_relationship_optional.body_html}`
        );*/
        // $($(`#product-${product.id} .summary.entry-summary .price-stock`)[0]).remove();
        $($(`#product-${product.id} .summary.entry-summary .btn-atc`)[0]).html('');
        $($(`#product-${product.id} .summary.entry-summary .product_meta`)[0]).html('');
        print_relationship_optional();
    }
}

const done_get_metafields = ({ response }) => {
    metafields = response.metafields;
    relationship = metafields.find((meta) => meta.key === "relationship");
    relationship_optional = metafields.find((meta) => meta.key === "relationship_2");
    if (relationship) {
        _get({
            apiUrl: `/admin/api/2019-10/products/${relationship.value}.json`
        }).done(done_get_product_relationship);
    }

    if (relationship_optional) {
        apiUrl({
            url: `/admin/api/2019-10/products/${relationship_optional.value}.json`
        }).done(done_get_product_relationship_optinal);
    }
}

const add_to_card = () => {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#cart-form-relationship').serialize(),
        success: (response) => {
            console.log('response', response);
        },
        error: (error) => {
            console.log('error', error);
        }
    });
}

const add_to_card_optional = () => {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#cart-form-relationship-optional').serialize(),
        success: (response) => {
            console.log('response', response);
        },
        error: (error) => {
            console.log('error', error);
        }
    });
}

const selected_options_relationship = (elem) => {
    const $element = $(elem);
    const option = ($element.attr('data-option-variant'));
    const value = ($element.attr('data-value-variant'));
    const index_parent = ($element.attr('data-parent-variant'));
    const index = ($element.attr('data-index-variant'));

    $(`.option-${option.toLocaleLowerCase()}-relationship`)
        .each((index, element) => {
            $(element).removeClass('is-selected');
        });
    $element.addClass('is-selected');

    const keys = [];

    $('#content-relationship .variations-relationship .is-selected')
        .each((i, element) => {
            keys.push($(element).attr('data-value-variant'));
        });
    const { variants } = product_relationship;
    const selected = variants.find(variant => variant.title === keys.join(' / '));
    $('.select-product-selected-relationship').val(selected.id);

    $('#productPriceRelationship').html(
        Shopify.formatMoney(selected.price, shopConfig.money_format)
    );

    $('.content-entry-summary-relationship .produc-no-in-stock')[selected.inventory_quantity > 0 ? 'addClass' : 'removeClass']('hiden hidden hide');
    $('.content-entry-summary-relationship .quantity-relationship')[selected.inventory_quantity > 0 ? 'removeClass' : 'addClass']('hiden hidden hide');
    $('.content-entry-summary-relationship .shopify_add_to_cart')[selected.inventory_quantity > 0 ? 'removeClass' : 'addClass']('hiden hidden hide');

    $('.content-entry-summary-relationship .availability')
        .html(`
    <div class="availability ${selected.inventory_quantity > 0 ? 'value_in' : 'value_out'}">
    ${selected.inventory_quantity <= 0 ? 'No' : ''} Disponible
    </div>
  `);
    $(`#content-relationship .optios-title-${option.toLocaleLowerCase()}`).html(`${option}: ${value}`);
}

const selected_options_relationship_optional = (elem) => {
    const $element = $(elem);
    const option = ($element.attr('data-option-variant'));
    const value = ($element.attr('data-value-variant'));
    const index_parent = ($element.attr('data-parent-variant'));
    const index = ($element.attr('data-index-variant'));

    $(`.option-${option.toLocaleLowerCase()}-relationship-optional`)
        .each((index, element) => {
            $(element).removeClass('is-selected');
        });
    $element.addClass('is-selected');

    const keys = [];

    $(`#product-${product.id} .variations-relationship-optional .is-selected`)
        .each((i, element) => {
            keys.push($(element).attr('data-value-variant'));
        });

    const { variants } = product_relationship_optional;
    const selected = variants.find(variant => variant.title === keys.join(' / '));

    if (selected) {

        $('.select-product-selected-relationship-optional').val(selected.id);

        // $('#productPriceRelationshipOptional').html(
        //   Shopify.formatMoney(selected.price)
        // );

        $($(`#product-${product.id} .summary.entry-summary #product-price`)[0]).html(
            Shopify.formatMoney(selected.price, shopConfig.money_format)
        );

        $('.content-entry-summary-relationship-optional .produc-no-in-stock')[selected.inventory_quantity > 0 ? 'addClass' : 'removeClass']('hiden hidden hide');
        $('.content-entry-summary-relationship-optional .quantity-relationship-optional')[selected.inventory_quantity > 0 ? 'removeClass' : 'addClass']('hiden hidden hide');
        $('.content-entry-summary-relationship-optional .shopify_add_to_cart')[selected.inventory_quantity > 0 ? 'removeClass' : 'addClass']('hiden hidden hide');

        /** $('.content-entry-summary-relationship-optional .availability')
        .html(`
          <div class="availability ${selected.inventory_quantity > 0 ? 'value_in' : 'value_out'}">
          ${selected.inventory_quantity <= 0 ? 'No' : ''} Disponible
          </div>
        `);*/

        $($(`#product-${product.id} .summary.entry-summary #product-available`)[0])
            .html(`
    <div class="availability ${selected.inventory_quantity > 0 ? 'value_in' : 'value_out'}">
    ${selected.inventory_quantity <= 0 ? 'No' : ''} Disponible
    </div>
  `);
    }
    if (product) {
        $(`#product-${product.id} .variations-relationship-optional .optios-title-${option.toLocaleLowerCase()}`).html(`${option}: ${value}`);
    }
}

const validate_lowecase = (opt, value) => {
    if (opt && value) {
        return opt.toLocaleLowerCase() == value.toLocaleLowerCase()
    }
    return false;
}

const build_variants = () => {
    const { options, variants } = product_relationship;
    let html = `<div class="content-options variations variant_square variations-relationship">`;

    options.forEach((option, index) => {
        html += `<div class="nt_select_pr_${index}-relationship is-nt${option.name.toLocaleLowerCase()} swatch is-label" data-option-index="${index}" id="nt_select_pr_${index}-relationship">
              <h4
                class="swatch__title optios-title-${option.name.toLocaleLowerCase()}">
                  ${option.name}: <span class="nt_name_current">${option.values[0]}</span>
              </h4>`;
        html += `<ul class="swatches-select swatch__list is-flex" data-attribute="pa_${option.name.toLocaleLowerCase()}" data-id="${index}" data-size="3">`;
        option.values.forEach((value, key) => {
            let _print_ = true;
            if (option.name.toLocaleLowerCase() == 'silueta' || option.name.toLocaleLowerCase() == 'talla') {

                let valid_quantity = variants.find(
                    variant =>
                    ((
                        validate_lowecase(variant.option1, value) ||
                        validate_lowecase(variant.option2, value) ||
                        validate_lowecase(variant.option3, value)
                    ) && !!variant.inventory_quantity > 0)
                );
                if (!valid_quantity) {
                    _print_ = false;
                }
            }

            if (_print_) {
                html += `
            <li
              data-index="${key}"
              aria-label="${value.toUpperCase()}"
              class="
                gecko-swatch
                is-relative
                bg_css_${normalize_class(value).toLocaleLowerCase()}
                swatch-${option.name.toLocaleLowerCase()}-small
                option-${option.name.toLocaleLowerCase()}-relationship
                ${key === 0 && 'is-selected'}
              "
              data-value="${value.toLocaleLowerCase()}"
              data-bcvalue="bc_${normalize_class(value).toLocaleLowerCase()}"
              data-option-variant="${option.name}"
              data-value-variant="${value}"
              data-parent-variant="${index}"
              data-index-variant="${key}"
              onclick="selected_options_relationship(this);">
                <span class="options-value-title">${value.toLocaleLowerCase()}</span>
                <span class="swatch__value bg_color bg_color_${value.toLocaleLowerCase()}"></span>
            </li>`;
            }
        });
        html += `</ul>
            </div>`;
    });

    html += `</div>`;

    return html;
}

const build_variants_optional = () => {
    const { options } = product_relationship_optional;
    let html = `<div class="content-options variations variant_square variations-relationship-optional">`;

    options.forEach((option, index) => {
        html += `<div class="nt_select_pr_${index}-relationship-optional is-nt${option.name.toLocaleLowerCase()} swatch is-label" data-option-index="${index}" id="nt_select_pr_${index}-relationship-optional">
              <h4
                class="swatch__title optios-title-${option.name.toLocaleLowerCase()}">
                  ${option.name}: <span class="nt_name_current">${option.values[0]}</span>
              </h4>`;
        html += `<ul class="swatches-select swatch__list is-flex" data-attribute="pa_${option.name.toLocaleLowerCase()}" data-id="${index}" data-size="3">`;
        option.values.forEach((value, key) => {
            let _print_ = true;
            if (option.name.toLocaleLowerCase() == 'silueta' || option.name.toLocaleLowerCase() == 'talla') {

                let valid_quantity = variants.find(
                    variant =>
                    ((
                        variant.option1.toLocaleLowerCase() == value.toLocaleLowerCase() ||
                        variant.option2.toLocaleLowerCase() == value.toLocaleLowerCase() ||
                        variant.option3.toLocaleLowerCase() == value.toLocaleLowerCase()
                    ) && !!variant.inventory_quantity > 0)
                );
                if (!valid_quantity) {
                    _print_ = false;
                }
            }

            if (_print_) {
                html += `
            <li
              data-index="${key}"
              aria-label="${value.toUpperCase()}"
              class="
                gecko-swatch
                is-relative
                bg_css_${normalize_class(value).toLocaleLowerCase()}
                bg_css_${normalize_class(value).toLocaleLowerCase()}
                swatch-${option.name.toLocaleLowerCase()}-small
                option-${option.name.toLocaleLowerCase()}-relationship-optional
                ${key === 0 && 'is-selected'}
              "
              data-value="${value.toLocaleLowerCase()}"
              data-bcvalue="bc_${normalize_class(value).toLocaleLowerCase()}"
              data-option-variant="${option.name}"
              data-value-variant="${value}"
              data-parent-variant="${index}"
              data-index-variant="${key}"
              onclick="selected_options_relationship_optional(this);">
                <span class="options-value-title">${value.toLocaleLowerCase()}</span>
                <span class="swatch__value bg_color bg_color_${value.toLocaleLowerCase()}"></span>
            </li>`;
            }
        });
        html += `</ul>
            </div>`;
    });

    html += `</div>`;

    return html;
}

const build_select_products_ids = () => {
    const { variants } = product_relationship;
    let html = '<select name="id" id="product-select" class="select-product-selected-relationship product-select_pr product-form__variants hiden hidden">';
    variants.forEach(variant => {
        html += `
        <option value="${variant.id}" class="nt_sold_out xs nt1_white nt2_tanga">${variant.title}</option>
      `;
    });
    html += `</select>`;
    return html;
}

const build_select_products_ids_optional = () => {
    const { variants } = product_relationship_optional;
    let html = '<select name="id" id="product-select" class="select-product-selected-relationship-optional product-select_pr product-form__variants hiden hidden">';
    variants.forEach(variant => {
        html += `
        <option value="${variant.id}" class="nt_sold_out xs nt1_white nt2_tanga">${variant.title}</option>
      `;
    });
    html += `</select>`;
    return html;
}


const print_relationship = () => {
    const { variants, title, body_html: description, options, id } = product_relationship;
    const html = `
  <div class="summary entry-summary content-entry-summary-relationship">
    <h1 class="product_title entry-title">${title}</h1>
    <div class="price-stock flex between-xs middle-xs mt__15 pb__15 mb__20" itemprop="offers" itemscope=""
      itemtype="http://schema.org/Offer">
      <div>
        <p class="price productPrice" id="productPriceRelationship"></p>
      </div>
      <div class="availability value_in" id="product-available">In Stock</div>
    </div>

    <div class="Shopify-product-details__short-description hiden hidden">
      <p class="p_des_ex">
        ${description}
      </p>
    </div>

    <div class="btn-atc atc-popup clearfix">
    <div id="callBackVariant" class="jas_s jas1_white jas2_cheeky">
      <form method="post" action="/cart/add" id="cart-form-relationship" accept-charset="UTF-8"
        class="variations_form product-form nt_cart_form jas_cart clearfix ng-pristine ng-valid"
        enctype="multipart/form-data" style="display: block;">
        <input type="hidden" name="form_type" value="product" autocomplete="off">
        <input
          type="hidden" name="utf8" value="✓" autocomplete="off">

          ${build_select_products_ids()}
          ${build_variants()}

        <div class="single_variation_wrap product-form__item--payment-button">
          <div class="shopify-variation single_variation"></div>
          <div class="shopify-variation-add-to-cart variations_button shopify-variation-add-to-cart-enabled">
            <div id="variantQuantity" class="variant-quantity variantQuantity" style="display: none"></div>
            <div class="flex">
              <p class="stock out-of-stock" id="out-of-stock-gl" style="display: none">Out of stock</p>
              <p class="stock out-of-stock hide hidden produc-no-in-stock" id="out-of-stock-gl" style="display: inline-block;">No Disponible</p>
              <div class="quantity pr fl quantity-relationship" id="shopify_quantity">
                <input type="number" step="1" min="1" max="10" name="quantity" value="1" title="Qty"
                  class="qty input-text tc" size="4">
                <div class="tc pa">
                  <a class="plus db cb" href="javascript:void(0);"><i class="fa fa-angle-up"></i></a>
                  <a class="minus db cb" href="javascript:void(0);"><i class="fa fa-angle-down"></i></a>
                </div>
              </div>
              <div id="container-add-favorites"></div>
                <button type="button" onclick="add_to_card()"
                  data-ntid="2310692798518"
                  class="shopify_add_to_cart jas_btn_2d ajax_form_cart single_add_to_cart_button button alt">
                  <span class="bt__text">Agregar al carrito</span>
                </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  </div>`;

    $contentRelationship.html(html);

    $('#productPriceRelationship').html(
        Shopify.formatMoney(variants[0].price, shopConfig.money_format)
    );

    // const guieZise = $('.summary.entry-summary .swatch__title.extra-link a')
    // .clone();
    // if(guieZise.length) {
    //   $('.swatch__title.optios-title-size')
    //   .append(guieZise)
    //   .addClass('extra-link');
    // }


    $('.summary.entry-summary .yith-wcwl-add-to-wishlist')
        .clone()
        .appendTo('#container-add-favorites');

    $('#container-add-favorites .yith-wcwl-add-to-wishlist')
        .removeClass(`add-to-wishlist-${product.id}`)
        .addClass(`add-to-wishlist-${product_relationship.id}`);

    $('#container-add-favorites .yith-wcwl-add-to-wishlist a')
        .attr(`data-id`, product_relationship.id)
        .attr(`data-handle`, product_relationship.handle);

    const keys = [];

    $('.variations-relationship .is-selected')
        .each((i, element) => {
            keys.push($(element).attr('data-value-variant'));
        });

    const { variants: variants_relationship } = product_relationship;
    const selected = variants_relationship.find(variant => variant.title === keys.join(' / '));

    if (selected) {
        $('.content-entry-summary-relationship .produc-no-in-stock')[selected.inventory_quantity > 0 ? 'addClass' : 'removeClass']('hiden hidden hide');
        $('.content-entry-summary-relationship .quantity-relationship')[selected.inventory_quantity > 0 ? 'removeClass' : 'addClass']('hiden hidden hide');
        $('.content-entry-summary-relationship .shopify_add_to_cart')[selected.inventory_quantity > 0 ? 'removeClass' : 'addClass']('hiden hidden hide');

        $('.content-entry-summary-relationship .availability')
            .html(`
          <div class="availability ${selected.inventory_quantity > 0 ? 'value_in' : 'value_out'}">
          ${selected.inventory_quantity <= 0 ? 'No' : ''} Disponible
          </div>
        `);
    }

}

const print_relationship_optional = () => {
    const { variants, title, body_html: description, options, id } = product_relationship_optional;
    const html = `
  <div class="summary entry-summary content-entry-summary-relationship-optional">

    <h1 class="product_title entry-title">${title}</h1>

    <div class="price-stock flex between-xs middle-xs pb__15 mb__20" itemprop="offers" itemscope=""
      itemtype="http://schema.org/Offer">
      <div>
        <p class="price productPrice" id="productPriceRelationshipOptional"></p>
      </div>
      <div class="availability value_in product-relationship-optional-price" id="product-available">In Stock</div>
    </div>

    <div class="btn-atc atc-popup clearfix">
    <div id="callBackVariant" class="jas_s jas1_white jas2_cheeky">
      <form method="post" action="/cart/add" id="cart-form-relationship-optional" accept-charset="UTF-8"
        class="variations_form product-form nt_cart_form jas_cart clearfix ng-pristine ng-valid"
        enctype="multipart/form-data" style="display: block;">
        <input type="hidden" name="form_type" value="product" autocomplete="off">
        <input
          type="hidden" name="utf8" value="✓" autocomplete="off">

          ${build_select_products_ids_optional()}
          ${build_variants_optional()}

        <div class="single_variation_wrap product-form__item--payment-button">
          <div class="shopify-variation single_variation"></div>
          <div class="shopify-variation-add-to-cart variations_button shopify-variation-add-to-cart-enabled">
            <div id="variantQuantity" class="variant-quantity variantQuantity" style="display: none"></div>
            <div class="flex">
              <p class="stock out-of-stock" id="out-of-stock-gl" style="display: none">Out of stock</p>
              <p class="stock out-of-stock hide hidden produc-no-in-stock" id="out-of-stock-gl" style="display: inline-block;">No Disponible</p>
              <div class="quantity pr fl quantity-relationship-optional" id="shopify_quantity">
                <input type="number" step="1" min="1" max="10" name="quantity" value="1" title="Qty"
                  class="qty input-text tc" size="4">
                <div class="tc pa">
                  <a class="plus db cb" href="javascript:void(0);"><i class="fa fa-angle-up"></i></a>
                  <a class="minus db cb" href="javascript:void(0);"><i class="fa fa-angle-down"></i></a>
                </div>
              </div>
              <div id="container-add-favorites"></div>
                <button type="button" onclick="add_to_card_optional()"
                  data-ntid="2310692798518"
                  class="shopify_add_to_cart jas_btn_2d ajax_form_cart single_add_to_cart_button button alt">
                  <span class="bt__text">Agregar al carrito</span>
                </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  </div>`;
    $($(`#product-${product.id} .summary.entry-summary .product_meta`)[0]).html(html);
    $contentRelationship.html(html);

    //$($(`#product-${product.id} .summary.entry-summary #product-price`)[0]).html(
    //  Shopify.formatMoney(variants[0].price)
    //);

    $('#productPriceRelationshipOptional').html(
        Shopify.formatMoney(variants[0].price, shopConfig.money_format)
    );

    // const guieZise = $('.summary.entry-summary .swatch__title.extra-link a')
    // .clone();
    // if(guieZise.length) {
    //   $('.swatch__title.optios-title-size')
    //   .append(guieZise)
    //   .addClass('extra-link');
    // }

    $('.summary.entry-summary .yith-wcwl-add-to-wishlist')
        .clone()
        .appendTo('#container-add-favorites');

    // $('#container-add-favorites .yith-wcwl-add-to-wishlist')
    //   .removeClass(`add-to-wishlist-${product.id}`)
    //   .addClass(`add-to-wishlist-${product_relationship.id}`);

    // $('#container-add-favorites .yith-wcwl-add-to-wishlist a')
    //   .attr(`data-id`, product_relationship.id)
    //   .attr(`data-handle`, product_relationship.handle);

    const keys = [];

    $('.variations-relationship-optional .is-selected')
        .each((i, element) => {
            keys.push($(element).attr('data-value-variant'));
        });

    const { variants: variants_relationship } = product_relationship_optional;
    const selected = variants_relationship.find(variant => variant.title === keys.join(' / '));
    if (selected) {
        $('.content-entry-summary-relationship-optional .produc-no-in-stock')[selected.inventory_quantity > 0 ? 'addClass' : 'removeClass']('hiden hidden hide');
        $('.content-entry-summary-relationship-optional .quantity-relationship-optional')[selected.inventory_quantity > 0 ? 'removeClass' : 'addClass']('hiden hidden hide');
        $('.content-entry-summary-relationship-optional .shopify_add_to_cart')[selected.inventory_quantity > 0 ? 'removeClass' : 'addClass']('hiden hidden hide');

        $($(`#product-${product.id} .summary.entry-summary #product-available`)[0])
            .html(`
        <div class="availability ${selected.inventory_quantity > 0 ? 'value_in' : 'value_out'}">
        ${selected.inventory_quantity <= 0 ? 'No' : ''} Disponible
        </div>
      `);
    }


    // $('.content-entry-summary-relationship-optional .availability')
    //   .html(`
    //     <div class="availability ${selected.inventory_quantity > 0 ? 'value_in' : 'value_out'}">
    //     ${selected.inventory_quantity <= 0 ? 'No' : ''} Disponible
    //     </div>
    //   `);


}

const normalize_class = (str) => {
    return str
        .trim()
        .toLocaleLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        .replace(/ /gi, '-');
}

const print_custom_filters = (response) => {
    // all_products = response.products;


    all_products.forEach((prod) => {
        if (prod) {
            prod.options.forEach((opt) => {
                if (opt.name == "Silueta" || opt.name == "silueta" || opt.name == "Silhouette" || opt.name == "silhouette") {
                    opt.values.forEach((value) => {
                        if (!siluetas.find(elem => normalize_class(elem) == normalize_class(value))) {
                            siluetas.push(value);
                        }
                    });
                }
                if (opt.name == "Color" || opt.name == "color" || opt.name == "Colour" || opt.name == "colour") {
                    opt.values.forEach((value) => {
                        if (!colors.find(elem => normalize_class(elem) == normalize_class(value))) {
                            colors.push(value);
                        }
                    });
                }
                if (opt.name == "Talla" || opt.name == "talla" || opt.name == "Size" || opt.name == "size") {
                    opt.values.forEach((value) => {
                        if (!tallas.find(elem => normalize_class(elem) == normalize_class(value))) {
                            tallas.push(value);
                        }
                    });
                }
                if (opt.name == "Copa" || opt.name == "copa" || opt.name == "Cup" || opt.name == "cup") {
                    opt.values.forEach((value) => {
                        if (!copas.find(elem => normalize_class(elem) == normalize_class(value))) {
                            copas.push(value);
                        }
                    });
                }
                if (opt.name == "Corte" || opt.name == "corte" || opt.name == "Cutting" || opt.name == "cutting") {
                    opt.values.forEach((value) => {
                        if (!cortes.find(elem => normalize_class(elem) == normalize_class(value))) {
                            cortes.push(value);
                        }
                    });
                }
            });
        }

    });

    let _html_filter = `
    <div class="nt_select_pr_2 swatch is-label">
    <h3 class="widget-title tu fwsb">by Silhouette</h3>
      <ul class="swatches-select swatch__list is-flex">`;
    siluetas.forEach((val) => {

      let isSilutaClassInitial = '';
      if(params.filter_attr_silueta && params.filter_attr_silueta === val) {
        isSilutaClassInitial = ' is-selected ';
      }

        _html_filter += `
            <li class="gecko-swatch swatch__list--item is-relative gecko-tooltip bg_css_${normalize_class(val)} swatch-size-small ${isSilutaClassInitial}"
              onclick="on_click_filter(this);"
              data-attr-opt-silueta="${val}"
              data-attr-type-filter="silhouette"
              data-attr-opt-silueta-normalizw="${normalize_class(val)}"
            >
              <span class="swatch__value">
                <span class="jas_nt_title">
                  ${val}
                </span>
              </span>
            </li>
            `;
    });

    _html_filter += `</ul></div>`

    let _html_filter_tallas = `
    <aside class="jas_ajaxFilter widget yith-shopify-ajax-product-filter yith-woo-ajax-navigation shopify widget_layered_nav">
      <h3 class="widget-title tu fwsb">by Size</h3>
      <ul class="yith-wcan-label yith-wcan yith-wcan-group">`;
    let _tallas_sort = tallas.sort(sortForSize);
    _tallas_sort.forEach((val) => {

      let isTallasClassInitial = '';
      if(params.filter_attr_talla && params.filter_attr_talla === val) {
        isTallasClassInitial = ' is-selected ';
      }

        _html_filter_tallas += `
            <li
            class="${isTallasClassInitial}"
              onclick="on_click_filter(this);"
              data-attr-type-filter="size"
              data-attr-opt-talla="${val}"
              data-attr-opt-talla-normalizw="${normalize_class(val)}"
            >
              <a>
                ${val}
              </a>
            </li>
            `;
    });

    _html_filter_tallas += `</ul></aside>`;



    let _html_filter_colors = `
      <aside class="jas_ajaxFilter widget yith-shopify-ajax-product-filter yith-woo-ajax-navigation shopify widget_layered_nav">
        <h3 class="widget-title tu fwsb">by Colour</h3>
          <ul class="yith-wcan-color yith-wcan yith-wcan-group jas_filter_color">`;

    colors.forEach((val) => {

      let isColorsClassInitial = '';
      if(params.filter_attr_color && params.filter_attr_color === val) {
        isColorsClassInitial = ' is-selected ';
      }

        _html_filter_colors += `
              <li
              class="${isColorsClassInitial}"
                onclick="on_click_filter(this);"
                data-attr-opt-color="${val}"
                data-attr-type-filter="colour"
                data-attr-opt-color-normalizw="${normalize_class(val)}"
              >
                <a class="bg_color_${normalize_class(val)}"></a>
              </li>
              `;
    });

    _html_filter_colors += `</ul></aside>`;

    let _html_filter_copas = `
      <aside class="jas_ajaxFilter widget yith-shopify-ajax-product-filter yith-woo-ajax-navigation shopify widget_layered_nav">
        <h3 class="widget-title tu fwsb">by Cup</h3>
        <ul class="yith-wcan-label yith-wcan yith-wcan-group">`;
    let _copas_sort = copas.sort();
    _copas_sort.forEach((val) => {

      let isCopaClassInitial = '';
      if(params.filter_attr_copa && params.filter_attr_copa === val) {
        isCopaClassInitial = ' is-selected ';
      }

        _html_filter_copas += `
              <li
              class="${isCopaClassInitial}"
                onclick="on_click_filter(this);"
                data-attr-type-filter="cup"
                data-attr-opt-copa="${val}"
                data-attr-opt-copa-normalizw="${normalize_class(val)}"
              >
                <a>
                  ${val}
                </a>
              </li>
              `;
    });

    _html_filter_copas += `</ul></aside>`;

    let _html_filter_cortes = `
      <aside class="jas_ajaxFilter widget yith-shopify-ajax-product-filter yith-woo-ajax-navigation shopify widget_layered_nav">
        <h3 class="widget-title tu fwsb">by Cutting</h3>
        <ul class="yith-wcan-label yith-wcan yith-wcan-group">`;
    let _cortes_sort = cortes.sort();
    _cortes_sort.forEach((val) => {

      let isCorteClassInitial = '';
      if(params.filter_attr_corte && params.filter_attr_corte === val) {
        isCorteClassInitial = ' is-selected ';
      }

        _html_filter_cortes += `
              <li
              class="${isCorteClassInitial}"
                onclick="on_click_filter(this);"
                data-attr-type-filter="cutting"
                data-attr-opt-corte="${val}"
                data-attr-opt-corte-normalizw="${normalize_class(val)}"
              >
                <a>
                  ${val}
                </a>
              </li>
              `;
    });

    _html_filter_cortes += `</ul></aside>`;

    if (siluetas.length)
        $('#filter-custom-siluetas')
        .html(_html_filter);
    if (colors.length)
        $('#filter-custom-colors')
        .html(_html_filter_colors);
    if (tallas.length)
        $('#filter-custom-tallas')
        .html(_html_filter_tallas);
    if (copas.length)
        $('#filter-custom-copas')
        .html(_html_filter_copas);
    if (cortes.length)
        $('#filter-custom-cortes')
        .html(_html_filter_cortes);
}

const on_click_filter = (event) => {

  console.info('params', params);

    let attrTypeFilter = $($(event)).attr('data-attr-type-filter');

    if ($(event).hasClass('is-selected')) {
        $(event).removeClass('is-selected');
    } else {
        $(`[data-attr-type-filter="${attrTypeFilter}"]`).removeClass('is-selected');
        $(event).addClass('is-selected');
    }

    filter_attr_silueta = $('#filter-custom-siluetas li.is-selected').attr('data-attr-opt-silueta');
    filter_attr_color = $('#filter-custom-colors li.is-selected').attr('data-attr-opt-color');
    filter_attr_talla = $('#filter-custom-tallas li.is-selected').attr('data-attr-opt-talla');
    filter_attr_copa = $('#filter-custom-copas li.is-selected').attr('data-attr-opt-copa');
    filter_attr_corte = $('#filter-custom-cortes li.is-selected').attr('data-attr-opt-corte');
    localStorage.setItem('filter_attr_silueta', filter_attr_silueta);
    localStorage.setItem('filter_attr_color', filter_attr_color);
    localStorage.setItem('filter_attr_talla', filter_attr_talla);
    localStorage.setItem('filter_attr_copa', filter_attr_copa);
    localStorage.setItem('filter_attr_corte', filter_attr_corte);

    const attrs = {
      filter_attr_silueta,
      filter_attr_color,
      filter_attr_talla,
      filter_attr_copa,
      filter_attr_corte,
    };

    const url = new URL(window.location);

    Object.keys(attrs).map((attr) => {
      if(attrs[attr]) {
        url.searchParams.set(attr, attrs[attr]);
      } else {
        url.searchParams.delete(attr, attrs[attr]);
      }
    });

    window.history.pushState(null, '', url.toString());

}

const filter_silueta_initial = (event) => {
    all_active = [];
    $(`.product-attr-size-container`).show();
    let attrTypeFilter = $($(event)).attr('data-attr-type-filter');


    let _height_parent = 0;
    const all = $(`.product-attr-size-container`)
        .each((index, element) => {
            cssArray.push($('> div', $(element)).css(['width', 'top', 'left', 'position']));
        });

    $(`[data-attr-type-filter="${attrTypeFilter}"]`).removeClass('is-selected');
    $(event).addClass('is-selected');

    filter_attr_silueta = $('#filter-custom-siluetas li.is-selected').attr('data-attr-opt-silueta');
    filter_attr_color = $('#filter-custom-colors li.is-selected').attr('data-attr-opt-color');
    filter_attr_talla = $('#filter-custom-tallas li.is-selected').attr('data-attr-opt-talla');
    filter_attr_copa = $('#filter-custom-copas li.is-selected').attr('data-attr-opt-copa');
    filter_attr_corte = $('#filter-custom-cortes li.is-selected').attr('data-attr-opt-corte');


    $(`.product-attr-size-container`).hide();

    $(`.product-attr-size-container`)
        .each((i, elem) => {
            let _siluetas = $(elem).attr('data-attr-siluetas').split('@:@');
            let _tallas = $(elem).attr('data-attr-tallas').split('@:@');
            let _colors = $(elem).attr('data-attr-colors').split('@:@');
            let _copas = $(elem).attr('data-attr-copas').split('@:@');
            let _cortes = $(elem).attr('data-attr-cortes').split('@:@');
            let _has_silueta = true;
            let _has_talla = true;
            let _has_color = true;
            let _has_copa = true;
            let _has_corte = true;

            if (filter_attr_silueta && !_siluetas.find(s => s == filter_attr_silueta)) {
                _has_silueta = false;
            }

            if (filter_attr_talla && !_tallas.find(s => s == filter_attr_talla)) {
                _has_talla = false;
            }

            if (filter_attr_color && !_colors.find(s => s == filter_attr_color)) {
                _has_color = false;
            }

            if (filter_attr_copa && !_copas.find(s => s == filter_attr_copa)) {
                _has_copa = false;
            }

            if (filter_attr_corte && !_cortes.find(s => s == filter_attr_corte)) {
                _has_corte = false;
            }

            if (_has_silueta && _has_talla && _has_color && _has_copa && _has_corte) {
                $(elem).show();
                all_active.push(elem);
                reposition_products_filtered(elem, all_active.length - 1, cssArray);
            }
        });

    let _length = all_active.length;
    const _w_document = $(document).width();
    let h_product = $('> div', all_active[0]).height() + 30;

    if (_w_document > 991) {
        if (_length === 1)
            _height_parent = h_product;
        if (_length > 2)
            _height_parent = h_product * 2;
        if (_length > 5)
            _height_parent = h_product * 3;
        if (_length > 9)
            _height_parent = h_product * 4;
        if (_length > 10)
            _height_parent = h_product * 5;
    } else if (_w_document >= 768 && _w_document <= 991) {
        _height_parent = Math.ceil(_length / 3) * h_product;
    } else {
        _height_parent = Math.ceil(_length / 2) * h_product;
    }

    /** $('.yit-wcan-container > .products')
     .css({
       height: `${_height_parent}px`
     });*/
}

const reposition_products_filtered = (element, position, cssArray) => {
    $('> div', element).css(cssArray[position]);
    const style = $('> div', element).attr('style');
    $('> div', element).attr('style', `${style} width: ${cssArray[position].width} !important;  max-width: ${cssArray[position].width} !important;`);

    $('a', element)
        .each((i, e) => {
            let bg = $(e).css('background-image');
            if (bg && bg !== 'none') {
                let newBg = bg.replace('_360x.', '_540x.');
                $(e).css({ backgroundImage: newBg })
            }
        });
}

const get_products_total = (last = 0) => {

    _get({
            apiUrl: `/admin/api/2019-10/products.json`,
            query: {
                collection_id: collection_id,
                since_id: last,
                limit: 250
            }
        })
        .done(({ response }) => {
            all_products = all_products.concat(response.products);
            if (until_current < until) {
                until_current = until_current + 1;
                get_products_total(response.products[response.products.length - 1].id);
            } else {
                print_custom_filters();
            }
        });
}


$(document).ready(function() {
    //console.log("ready! V2");
    _get({
            apiUrl: '/admin/shop.json',
        })
        .done(function({ response }) {
            try {
                shopConfig = response.shop;
                option.currency = response.shop.currency;
            } catch (error) {
                console.error('apiUrl: /admin/shop.json', error);
            }

        });

    if (last[0] === 'products') {
        $contentRelationship = $('#content-relationship');
        _get_web({
                url: `products/${last[1]}.json`
            })
            .done(function(response) {
                product = response.product;
                get_metafields(product)
                    .done(done_get_metafields);
                console.log("Metafields: ", get_metafields(product));
            });
    }
    const guia = "\/\/cdn.shopify.com\/s\/files\/1\/0277\/4768\/0328\/files\/GUIA-DE-TALLAS-touche-ILOT-INGLES.png?v=1702497221";

    /* $('.summary.entry-summary #cart-form').append(`
      <a class="extra-link guia-de-tallas" target="_blank" href='//touche.co/cdn/shop/files/GUIA-DE-TALLAS-touche-ILOT-INGLES.png?v=1702497221'>Size Guide</a>
    `) */


    //Active links on capanas
    $(function() {
        var current = location.pathname;
        $('li.menu-campana-item a').each(function() {
            var $this = $(this);
            // if the current path is like this link, make it active
            if ($this.attr('href').indexOf(current) !== -1) {
                $this.addClass('active');
            }
        })
    })
});


$(window).load(function() {
    if (split_pathname.length >= 3 && split_pathname.find(v => v == 'collections') && !split_pathname.find(v => v == 'products')) {
        // _get({
        //   //url: `admin/api/2019-10/collections/${collection__des.handle}?view=json`
        //   url: `admin/api/2019-10/products.json?collection_id=${collection_id}&limit=250`
        // })
        // .done(print_custom_filters);

        _get({
                //url: `admin/api/2019-10/collections/${collection__des.handle}?view=json`
                apiUrl: `/admin/api/2019-10/products/count.json`,
                query: {
                    collection_id: collection_id
                }
            })
            .done(({ response }) => {
                _total_count = response.count;
                until = Math.ceil(response.count / 250);
                get_products_total();
            });
    }

});

$(function() {
  jQuery('.filter-content').prepend('<div id="filters-remove">Quitar filtros</div>');
  jQuery('#filters-remove').click(function() {
    localStorage.setItem('filter_attr_silueta', 'undefined');
  	localStorage.setItem('filter_attr_color', 'undefined');
  	localStorage.setItem('filter_attr_talla', 'undefined');
  	localStorage.setItem('filter_attr_copa', 'undefined');
  	localStorage.setItem('filter_attr_corte', 'undefined');
    jQuery('.is-selected').removeClass('is-selected');
  });
});